import { Component } from '@theme/component';
import { formatCharacterCount, normalizePlaqueFinish } from './plaque-personalization-utils.js';

/**
 * Keeps plaque text, character counters, and the visual preview in sync.
 * The actual input elements stay mounted while Shopify resolves variants,
 * so changing product options cannot erase customer personalization.
 */
class PlaquePersonalization extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.productComponent = this.closest('product-component');
    this.productComponent?.addEventListener('change', this.handleVariantChange);

    for (const input of this.querySelectorAll('[data-plaque-input]')) {
      if (input instanceof HTMLInputElement) this.updatePreviewField(input);
    }

    this.updateFinish(this.dataset.initialFinish || 'neutral');
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.productComponent?.removeEventListener('change', this.handleVariantChange);
  }

  /** @param {InputEvent} event */
  handleInput(event) {
    if (!(event.target instanceof HTMLInputElement)) return;
    this.updatePreviewField(event.target);
  }

  /** @param {Event} event */
  handleVariantChange = (event) => {
    if (!(event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement)) return;
    if (event.target.dataset.optionName?.trim().toLowerCase() !== 'plaque finish') return;

    this.updateFinish(event.target.value);
  };

  /** @param {HTMLInputElement} input */
  updatePreviewField(input) {
    const key = input.dataset.plaqueInput;
    if (!key) return;

    const previewLine = this.querySelector(`[data-preview-line="${key}"]`);
    const counter = this.querySelector(`[data-counter-for="${key}"]`);

    if (previewLine) previewLine.textContent = input.value.trim() || input.placeholder;
    if (counter) counter.textContent = formatCharacterCount(input.value.length, input.maxLength);
  }

  /** @param {string} value */
  updateFinish(value) {
    const preview = this.querySelector('[data-plaque-preview]');
    if (!(preview instanceof HTMLElement)) return;

    preview.dataset.finish = normalizePlaqueFinish(value);
  }
}

if (!customElements.get('plaque-personalization')) {
  customElements.define('plaque-personalization', PlaquePersonalization);
}
